export const EXTERNAL_LINKS = {
  PUBLICATION_RANK:
    "https://platform-support.onclusive.com/en/articles/302159-publication-rank",
  NLA_CONTENT_RULES:
    "https://platform-support.onclusive.com/en/articles/409263-understanding-nla-content-rules-how-they-affect-your-search-results",
  RELEVANCE_SCORES:
    "https://platform-support.onclusive.com/en/articles/396008-understanding-relevance-scores",
  NLA_ECLIPS_URL:
    "https://www.nla-eclips.com/NLAAPI.dll/PCAClientRequest?PCA_ID=100",
  DIGEST_LOCKED_CONTENT:
    "https://platform-support.onclusive.com/en/articles/425205-managing-locked-and-unlocked-content-in-your-email-digests",
  MONITOR_ENQUIRY:
    "https://onclusive.com/en-gb/products/self-service-media-monitoring/#enquiry",
  CONTACTS_ENQUIRY:
    "https://onclusive.com/en-gb/products/media-contacts-events-database/#enquiry",
};
